var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trigger mt-5"},[_c('a-spin',{attrs:{"spinning":_vm.isLoading}},[(_vm.triggerModel)?_c('trigger-setup',{attrs:{"controls":{
        'view': _vm.TriggerControls,
        'props': {
          'disabled': _vm.isTriggerSetupDisabled
        },
        'listeners': _vm.controlsListeners
      },"disabled":_vm.isTriggerSetupDisabled},model:{value:(_vm.triggerModel),callback:function ($$v) {_vm.triggerModel=$$v},expression:"triggerModel"}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }